
import {
  removeAuthToken,
  removeImpersonationToken,
} from './api';

const PER_USER_KEY_PREFIXES = [
  'upsell_popup_closed_at:',
];

const GLOBAL_USER_KEYS = [
  'access_token',
  'user_uid',
  'user',
  'onboarding_intent',
  'onboarding_widget_dismissed',
];

export function clearAllUserState(): void {
  try {
    removeAuthToken();
    removeImpersonationToken();
  } catch {
  }

  try {
    GLOBAL_USER_KEYS.forEach((k) => localStorage.removeItem(k));
  } catch {
  }

  try {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i);
      if (!key) continue;
      if (PER_USER_KEY_PREFIXES.some((prefix) => key.startsWith(prefix))) {
        localStorage.removeItem(key);
      }
    }
  } catch {
  }
}
